import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tag, Ruler } from 'lucide-react';
import { CategoryManager } from '../components/CategoryManager';
import { SizeManager } from '../components/SizeManager';

export const Categories: React.FC = () => {
  const location = useLocation();
  const initialTab = (location.state as { tab?: 'categories' | 'sizes' } | null)?.tab ?? 'categories';
  const [activeTab, setActiveTab] = useState<'categories' | 'sizes'>(initialTab);

  return (
    <div className="space-y-6">
      {/* Tabs */}
      <div className="flex border-b border-page-border gap-6">
        <button
          onClick={() => setActiveTab('categories')}
          className={`flex items-center gap-2 pb-3 text-sm font-semibold transition-all relative ${
            activeTab === 'categories'
              ? 'text-brand-primary font-bold'
              : 'text-ink-muted hover:text-ink'
          }`}
        >
          <Tag className="w-4 h-4" />
          Categorías
          {activeTab === 'categories' && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-primary rounded-full animate-fade-in" />
          )}
        </button>
        <button
          onClick={() => setActiveTab('sizes')}
          className={`flex items-center gap-2 pb-3 text-sm font-semibold transition-all relative ${
            activeTab === 'sizes'
              ? 'text-brand-primary font-bold'
              : 'text-ink-muted hover:text-ink'
          }`}
        >
          <Ruler className="w-4 h-4" />
          Talles
          {activeTab === 'sizes' && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-primary rounded-full animate-fade-in" />
          )}
        </button>
      </div>

      <div>
        {activeTab === 'categories' ? <CategoryManager /> : <SizeManager />}
      </div>
    </div>
  );
};

